<template>
    <rkm-overlay>
        <rkm-layout-body title="Edição de registro de vacinação">
            <template v-slot:actions>
                <rkm-button
                    @click="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="$router.push({ name: 'imunizacao-fila-atendimento-index' })"
                    authorize="create-imunizacao-fila-atendimento"
                    color="primary"
                >
                    Fila de atendimento
                </rkm-button>

                <template v-if="additionals && additionals.salaVacinacaoLogada && !!additionals.salaVacinacaoLogada.id">
                    <rkm-button
                        @click="$refs.Form.printRegistroVacinacao()"
                        color="info"
                    >
                        Imprimir
                    </rkm-button>

                    <rkm-button
                        @click="$refs.Form.printCarteiraVacinacao()"
                        color="info"
                    >
                        Imprimir carteirinha de vacinação
                    </rkm-button>

                    <rkm-button
                        @click="$refs.Form.printCertidaoRegularidade()"
                        color="info"
                    >
                        Imprimir certidão de regularidade
                    </rkm-button>

                    <rkm-button
                        @click="$refs.Form.save()"
                        color="primary"
                    >
                        Salvar
                    </rkm-button>
                </template>
            </template>

            <rkm-layout-content>
                <Form
                    :key="formKey"
                    :fila-id="filaId"
                    :id="id"
                    @loaded="habdleLoaded"
                    @save="formKey++"
                    ref="Form"
                />
            </rkm-layout-content>

            <ModalIntegracaoCns
                @update="handleIntegracaoCnsUpdate"
                ref="ModalIntegracaoCns"
            />
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/imunizacao/registro-vacinacao/Form'
import ModalIntegracaoCns from '@/components/integracao/cns/components/busca//Modal'

// Enums.
import classificacao from '@/enums/cadastro/paciente/classificacao'

// Mixins.
import {error, repository, unmask} from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: {
        Form,
        ModalIntegracaoCns,
    },
    computed: {
        hasPermissaoAtualizacaoCadastroPaciente() {
            let hasPermissao = false

            if (this.additionals && this.additionals.permissoesAtualizacaoCadastroPaciente) {
                if (this.form && this.form.paciente.classificacaoId === this.enums.classificacao.MUNICIPE && this.additionals.permissoesAtualizacaoCadastroPaciente.municipe) {
                    hasPermissao = true
                }
                else if (this.form && this.form.paciente.classificacaoId === this.enums.classificacao.PROVISORIO && this.additionals.permissoesAtualizacaoCadastroPaciente.provisorio) {
                    hasPermissao = true
                }
                else if (this.form && this.form.paciente.classificacaoId === this.enums.classificacao.OUTRO_MUNICIPIO && this.additionals.permissoesAtualizacaoCadastroPaciente.outroMunicipio) {
                    hasPermissao = true
                }
            }

            return hasPermissao
        },
    },
    created() {
        this.repositories = {
            filaAtendimento: this.getConectaSusRepository('imunizacao.filaAtendimento'),
        }
    },
    data: () => ({
        additionals: null,
        enums: {classificacao},
        model: null,
        formKey: 1,
    }),
    methods: {
        ...mapActions([
            'setLoading',
            'setShowExitFormConfirmation',
            'unsetLoading',
            'unsetShowExitFormConfirmation',
        ]),
        habdleLoaded(object) {
            this.additionals = object.additionals
            this.model = object.model

            if (this.additionals && this.additionals.salaVacinacaoLogada && !!this.additionals.salaVacinacaoLogada.id) {
                this.setShowExitFormConfirmation()
            }
        },
        redirectToList() {
            this.unsetShowExitFormConfirmation()

            if (this.filaId) {
                this.$router.push('/imunizacao/fila-atendimento/index')
            } else {
                this.$router.push('/imunizacao/registro-vacinacao/index')
            }
        },
        handleSave() {
            this.redirectToList()
        },
        handleExit() {
            this.showExitConfirmation(async () => {
                if (this.filaId) {
                    this.setLoading()

                    return this.repositories.filaAtendimento.sendBack(this.filaId)
                        .then(() => this.redirectToList())
                        .finally(() => this.unsetLoading())
                } else {
                    this.redirectToList()
                }
            }, this.handleError)
        },
        handleBuscarDadosPacienteIntegracaoCns() {
            const params = {
                id: this.model.cidadaoId,
                nome: this.model.cidadaoNome,
                dataNascimento: this.model.cidadaoDataNascimento,
                nomeMae: this.model.cidadaoNomeMae,
                cns: this.model.cidadaoCns ? this.unMaskCns(this.model.cidadaoCns) : null,
                cpf: this.model.cidadaoCpf ? this.unMaskCpf(this.model.cidadaoCpf) : null,
            }

            this.$refs.ModalIntegracaoCns.open(params)
        },
        handleIntegracaoCnsUpdate(item) {
            Object.assign(this.form.paciente, {
                ...item,
                dataNascimento: item.dataNascimento ? this.others.moment(item.dataNascimento).format('DD/MM/YYYY') : null,
                idade: item.idadeFormatada,
            })
        },
    },
    mixins: [error, repository, unmask],
    props: {
        id: { type: Number, default: null },
        filaId: { type: Number, default: null },
    },
}
</script>